import { render, staticRenderFns } from "./StudioLogo.vue?vue&type=template&id=2b477847&scoped=true&"
import script from "./StudioLogo.vue?vue&type=script&lang=ts&"
export * from "./StudioLogo.vue?vue&type=script&lang=ts&"
import style0 from "./StudioLogo.vue?vue&type=style&index=0&id=2b477847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b477847",
  null
  
)

export default component.exports